import React from "react";

export default function AppointmentRequest() {
  return <div></div>;
}
